import React from 'react';
import AdapterLuxon from '@mui/lab/AdapterLuxon';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import TimePicker from '@mui/lab/TimePicker';
import { DateTime } from 'luxon';
import { Box } from '@mui/system';

interface EventTimePickerProps {
  initialDate: DateTime;
  label: string;
  handleChange: (newDateTime: DateTime) => void;
}

const EventTimePicker: React.FC<EventTimePickerProps> = ({ initialDate, label, handleChange }) => {
  const [value, setValue] = React.useState<DateTime | null>(initialDate);

  // TODO RT: we had to do some weird things to get this renderInput to play nice with
  // ionic, after removal of ionic see if we can revert to "out of the box" renderInput
  return (
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      <TimePicker
        label={label}
        value={value}
        onChange={(newValue) => {
          setValue(newValue);
        }}
        onAccept={(newValue) => {
          if (newValue) handleChange(newValue);
        }}
        renderInput={({ inputRef, inputProps, InputProps }) => {
          inputProps = { ...inputProps };
          inputProps.style = {
            textAlign: 'right',
            borderStyle: 'none',
            ...inputProps.style,
          };
          return (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <input ref={inputRef} {...inputProps} />
              {InputProps?.endAdornment}
            </Box>
          );
        }}
      />
    </LocalizationProvider>
  );
};

export default EventTimePicker;
